export default __webpack_public_path__ + "static/media/icosahedron.76ff877e.usdz";